import { MainApp } from './MainApp';
import { TrainingApp } from './routes/training/TrainingApp';
import { AppToaster } from './components/ui/Toaster';
import { usePortal } from './hooks/useAuth';
import { useRealtime } from './hooks/useRealtime';

/**
 * Top-level switch between the two served experiences. The portal is
 * resolved server-side from the hostname (see usePortal) so training.* gets
 * its own shell, nav and route tree with none of the onboarding/mobilisation
 * framing, while every other host gets the default app. Both share one
 * build, session and realtime subscription; only the route tree differs.
 */
export function App() {
  // Subscribe the whole tree to server-pushed event invalidations.
  // No-ops if the user is not signed in.
  useRealtime();
  const portal = usePortal();

  return (
    <>
      <AppToaster />
      {portal === 'training' ? <TrainingApp /> : <MainApp />}
    </>
  );
}
